import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const PageName = (props) => {

    const serverURL = getServerURL()
    const [modalShow, setModalShow] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [paginationData, setPaginationData] = useState({})
    const [states, setStates] = useState({ is_faq_page_only: false })
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([])
    const [deleteData, setDeleteData] = useState()
    const [loading, setLoading] = useState(true)
    const [mode, setMode] = useState()
    const [subLoader, setSubLoader] = useState(false)

    useEffect(() => {
        getPageName();
    }, [searchText]);

    const getPageName = (event) => {
        setLoading(true)
        api.getWithToken(`${serverURL}page/?is_faq_page_only=true&${searchText && `_s=${searchText}`}`)
            .then(async (res) => {
                setLoading(false)
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                if (res?.data?.success === true) {
                    setData(data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setStates((prevValues) => ({
                ...prevValues,
                [name]: checked,
            }));
        } else
            setStates((prevValues) => ({
                ...prevValues,
                [name]: value.trimStart(),
            }));
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        setSubLoader(true)
        event.preventDefault();
        if (form.checkValidity()) {
            setValidated(false);
            const type = Boolean(mode) ? "postWithToken" : "putWithToken";
            const formData = new FormData();
            formData.append("name", states?.name);
            formData.append("is_faq_page_only", states?.is_faq_page_only);
            if (states?.slug)
                formData.append("slug", states?.slug);
            api[type](`${serverURL}page/`, formData)
                .then(async (res) => {
                    setModalShow(false)
                    setStates({})
                    form.reset();
                    setLoading(false);
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getPageName();
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    errorResponse(e);
                    setSubLoader(false)
                });
        } else {
            setValidated(true);
            event.stopPropagation();
            setSubLoader(false)
        }
    };

    const deletePageName = () => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}page/${deleteData}`)
            .then(async (res) => {
                setDeleteModalShow(false)
                setSubLoader(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getPageName()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
            })
            .catch((e) => {
                errorResponse(e);
                setSubLoader(false)
            });
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                                <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); setStates({ is_faq_page_only: false }); setModalShow(true) }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Name</th>
                                <th>Is faq page only</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr>
                                        <td>
                                            {index + 1}
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.name || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.is_faq_page_only?.toString() || "-"} </h6>
                                        </td>

                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); setModalShow(true) }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                <div className='cursor-pointer' onClick={() => { setDeleteData(item?.slug); setDeleteModalShow(true) }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={3} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>}

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}

            {/* add modal */}
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "}{props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter page name here" required value={states?.name || ""} name='name' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter page name.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} controlId="formHorizontalCheck">
                                    <Form.Label as="legend" column lg={3}>
                                        Is faq page only
                                    </Form.Label>
                                    <Col sm={4}>
                                        <Form.Check label="True" name="is_faq_page_only" checked={states?.is_faq_page_only} onClick={handleChange} style={{ paddingBlock: "7px" }} />
                                    </Col>
                                </Form.Group>

                                <div className='d-flex justify-content-end'>
                                    <Button type='submit' className='m-0'>{Boolean(mode) ? "Save" : "Update"}</Button>
                                </div>

                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

            {/* Delete */}
            <Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deletePageName()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PageName